import ModalShare from './ModalShare'

export default ModalShare
// eslint-disable-next-line import/export
export * from './ModalShare'
